import React from "react";
import Navbar from "../layout/Navbar";
import imageOne from "../assests/Images/standard-quality-control-concept-m-min.jpg";
import imageTwo from "../assests/Images/standard-quality-control-concept-m-min.jpg";
import imageThree from "../assests/Images/Talent-mapping.png";
import Footer from "../layout/Footer";
import { useInView } from "react-intersection-observer";
import WaveEffect from "../Components/WaveEffect";

const Services = () => {
  const { ref: ref1, inView: inView1 } = useInView({
    triggerOnce: false,
    threshold: 0,
  });
  const { ref: ref2, inView: inView2 } = useInView({
    triggerOnce: false,
    threshold: 0,
  });
  const { ref: ref3, inView: inView3 } = useInView({
    triggerOnce: false,
    threshold: 0,
  });

  return (
    <div>
      <Navbar />
      <div
        className="bg-cover bg-center h-[75vh] lg:h-[75vh] md:h-[500px] sm:h-[400px] "
        style={{ backgroundImage: `url(${imageOne})` }}
      >
        <div className="h-full  bg-black bg-opacity-60 w-full flex flex-col justify-center items-center ">
          <h1 className="text-white text-4xl lg:text-6xl font-bold leading-tight">
            Technology Services
          </h1>
          <div className="h-1 lg:h-2 xl:h-2 2xl:h-2 mt-10 w-20 bg-white" />
          <p className="text-center text-white py-6 px-12 text-lg">
            At People Process Teck, we empower organizations through innovative
            technology, helping them navigate complexity, adapt to change, and
            achieve sustainable success in a fast-evolving business landscape.
          </p>
        </div>
      </div>

      <div ref={ref1} className="my-20 xl:px-20 lg:my-24">
        {inView1 && (
          <WaveEffect
            text={`Empowering businesses with cutting-edge technology solutions, digital automation,\nand industry-specific innovations for a smarter future.`}
            textClassName="font-bold text-center text-2xl xl:text-3xl leading-loose"
          />
        )}

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-y-5 my-20">
          <div className="flex items-center justify-center h-fit ">
            <div className="relative w-72 h-72 bg-white shadow-lg overflow-hidden transition-all duration-500 hover:h-[370px] group">
              <div
                className="absolute w-[450px] h-[400px]  bg-cover bg-bottom rounded-full -top-[270px] -left-[75px] transition-all duration-500 group-hover:rounded-none group-hover:-top-[130px]"
                style={{ backgroundImage: `url(${imageTwo})` }}
              ></div>
              <h2 className="absolute top-36 w-full text-center text-primary font-light text-xl transition-all duration-500 group-hover:bg-white group-hover:text-primary group-hover:font-extrabold  group-hover:p-1">
                Digital Transformation Services
              </h2>
              <p className="absolute text-center text-sm  transition-all duration-500 top-52 group-hover:top-[300px]">
                Strategies and solutions to integrate digital technology into
                all areas of business operations.
              </p>
            </div>
          </div>

          <div className="flex items-center justify-center h-fit">
            <div className="relative w-72 h-72 bg-white shadow-lg overflow-hidden transition-all duration-500 hover:h-[370px] group">
              <div
                className="absolute w-[450px] h-[400px]  bg-cover bg-bottom rounded-full -top-[270px] -left-[75px] transition-all duration-500 group-hover:rounded-none group-hover:-top-[130px]"
                style={{ backgroundImage: `url(${imageTwo})` }}
              ></div>
              <h2 className="absolute top-36 w-full text-center text-primary font-light text-xl transition-all duration-500 group-hover:bg-white group-hover:text-primary group-hover:font-extrabold  group-hover:p-1">
                IT Infrastructure Management
              </h2>
              <p className="absolute text-center text-sm  transition-all duration-500 top-52 group-hover:top-[300px]">
                Services ensuring optimized, secure, and scalable IT
                environments.
              </p>
            </div>
          </div>

          <div className="flex items-center justify-center h-fit">
            <div className="relative w-72 h-72 bg-white shadow-lg overflow-hidden transition-all duration-500 hover:h-[370px] group">
              <div
                className="absolute w-[450px] h-[400px]  bg-cover bg-bottom rounded-full -top-[270px] -left-[75px] transition-all duration-500 group-hover:rounded-none group-hover:-top-[130px]"
                style={{ backgroundImage: `url(${imageTwo})` }}
              ></div>
              <h2 className="absolute top-36 w-full text-center text-primary font-light text-xl transition-all duration-500 group-hover:bg-white group-hover:text-primary group-hover:font-extrabold  group-hover:p-1">
                Enterprise Resource Planning (ERP) Solutions
              </h2>
              <p className="absolute text-center text-sm  transition-all duration-500 top-52 group-hover:top-[300px]">
                Implementation and customization of ERP systems to streamline
                business processes.
              </p>
            </div>
          </div>

          <div className="flex items-center justify-center h-fit ">
            <div className="relative w-72 h-72 bg-white shadow-lg overflow-hidden transition-all duration-500 hover:h-[370px] group">
              <div
                className="absolute w-[450px] h-[400px]  bg-cover bg-bottom rounded-full -top-[270px] -left-[75px] transition-all duration-500 group-hover:rounded-none group-hover:-top-[130px]"
                style={{ backgroundImage: `url(${imageTwo})` }}
              ></div>
              <h2 className="absolute top-36 w-full text-center text-primary font-light text-xl transition-all duration-500 group-hover:bg-white group-hover:text-primary group-hover:font-extrabold  group-hover:p-1">
                Custom Software Development
              </h2>
              <p className="absolute text-center text-sm  transition-all duration-500 top-52 group-hover:top-[300px]">
                Tailored software solutions addressing unique business
                challenges.
              </p>
            </div>
          </div>

          <div className="flex items-center justify-center h-fit ">
            <div className="relative w-72 h-72 bg-white shadow-lg overflow-hidden transition-all duration-500 hover:h-[370px] group">
              <div
                className="absolute w-[450px] h-[400px]  bg-cover bg-bottom rounded-full -top-[270px] -left-[75px] transition-all duration-500 group-hover:rounded-none group-hover:-top-[130px]"
                style={{ backgroundImage: `url(${imageTwo})` }}
              ></div>
              <h2 className="absolute top-36 w-full text-center text-primary font-light text-xl transition-all duration-500 group-hover:bg-white group-hover:text-primary group-hover:font-extrabold  group-hover:p-1">
                IT Consulting and Strategy
              </h2>
              <p className="absolute text-center text-sm  transition-all duration-500 top-52 group-hover:top-[300px]">
                Expert guidance to align technology initiatives with business
                objectives.
              </p>
            </div>
          </div>
        </div>
        {/* <div className='grid lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-4 lg:h-[40rem] xl:h-[40rem] 2xl:h-[20rem] p-6 mt-16'>
        <div className='bg-cover bg-center rounded-md' style={{ backgroundImage: `url(${imageTwo})` }}>
          <div className='h-full bg-black/70 rounded-md p-6'>
            <h1 className='text-2xl font-bold text-white'>
              Digital Transformation Services
            </h1>
            <p className='text-xl text-white mt-4'>Strategies and solutions to integrate digital technology into all areas of business operations.</p>
          </div>
        </div>
        <div className='bg-cover bg-center rounded-md' style={{ backgroundImage: `url(${imageTwo})` }}>
          <div className='h-full bg-black/70 rounded-md p-6'>
            <h1 className='text-2xl font-bold text-white'>
              IT Infrastructure Management
            </h1>
            <p className='text-xl text-white mt-4'>
              Services ensuring optimized, secure, and scalable IT environments.
            </p>
          </div>
        </div>
        <div className='bg-cover bg-center rounded-md' style={{ backgroundImage: `url(${imageTwo})` }}>
          <div className='h-full bg-black/70 rounded-md p-6'>
            <h1 className='text-2xl font-bold text-white'>
              Enterprise Resource Planning (ERP) Solutions
            </h1>
            <p className='text-xl text-white mt-4'>
              Implementation and customization of ERP systems to streamline business processes.            </p>
          </div>
        </div>
        <div className='bg-cover bg-center rounded-md' style={{ backgroundImage: `url(${imageTwo})` }}>
          <div className='h-full bg-black/70 rounded-md p-6'>
            <h1 className='text-2xl font-bold text-white'>
              Custom Software Development
            </h1>
            <p className='text-xl text-white mt-4'>
              Tailored software solutions addressing unique business challenges.            </p>
          </div>
        </div>
        <div className='bg-cover bg-center rounded-md' style={{ backgroundImage: `url(${imageTwo})` }}>
          <div className='h-full bg-black/70 rounded-md p-6'>
            <h1 className='text-2xl font-bold text-white'>
              IT Consulting and Strategy
            </h1>
            <p className='text-xl text-white mt-4'>
              Expert guidance to align technology initiatives with business objectives.            </p>
          </div>
        </div>
      </div> */}
      </div>

      <div ref={ref2} className="bg-gray-100 xl:mb-20">
        {inView2 && (
          <WaveEffect
            text="Use of Skilled Manpower"
            textClassName="xl:text-5xl text-2xl text-center  font-bold"
            mainContainerClassName="p-6"
          />
        )}
        <div className="mt-6 grid lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 xl:px-20">
          <div className="p-6">
            <h1 className="">
              Technology alone cannot drive digital transformation—expert
              manpower is crucial in implementing, managing, and optimizing
              digital solutions. At People Process Teck, we provide highly
              skilled professionals to support your digital initiatives.
            </h1>
            <div className="mt-4 pb-6 border-b border-primary/80">
              <h1 className="text-lg">
                <span className="font-bold">Technology Consultants:</span> Our
                IT strategists assess your digital readiness and create a
                roadmap for successful transformation.
              </h1>
            </div>
            <div className="mt-4 pb-6 border-b border-primary/80">
              <h1 className="text-lg">
                <span className="font-bold">
                  Software Developers & Engineers:
                </span>{" "}
                Our skilled development team ensures the creation of robust,
                future-ready applications tailored to your needs.
              </h1>
            </div>
            <div className="mt-4 pb-6 border-b border-primary/80">
              <h1 className="text-lg">
                <span className="font-bold">Automation Specialists:</span>{" "}
                Experts in RPA, AI, and workflow automation help design and
                deploy efficient business processes.
              </h1>
            </div>
            <div className="mt-4 pb-6 border-b border-primary/80">
              <h1 className="text-lg">
                <span className="font-bold">Data Analysts & AI Experts:</span>{" "}
                Our data scientists use analytics and AI to derive meaningful
                insights and enhance business performance.
              </h1>
            </div>
            <div className="mt-4 pb-6 ">
              <h1 className="text-lg">
                <span className="font-bold">Cybersecurity Professionals:</span>
                We ensure your digital systems are secure, compliant, and
                protected from cyber threats.
              </h1>
            </div>
          </div>
          <div className="flex justify-center items-center">
            <img src={imageThree} alt="" />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Services;
